module.exports = __webpack_public_path__ + "img/11_68.18738b8d.png";